// Create a transport
import { createClient } from "@connectrpc/connect";
import { AuthService } from "@buf/alconostmt_services.bufbuild_es/alconost/mt/auth_pb";
import { createConnectTransport } from "@connectrpc/connect-web";

const transport = createConnectTransport({
    baseUrl: 'https://services-375925469890.us-central1.run.app'
});

const authService = createClient(AuthService, transport);

export const authLogin = async (token) => {
    try {
        const response = await authService.login({ token: token });
        // if (response && response.token) {
        //     localStorage.setItem('token', response.token);
        // }
        console.log(response);
        return response;
    } catch (error) {
        console.error('Error logging in:', error);
        throw error;
    }
};